var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAustriaFlag = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 9,
  height: 6,
  viewBox: "0 0 9 6"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#c8102e",
  d: "M0 0h9v6H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 2h9v2H0z"
})));
export { SvgAustriaFlag as ReactComponent };